import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/Home'
import Store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/member',
    name: 'Member',
    component: () => import(/* webpackChunkName: "member" */ '../pages/Member')
  },
  {
    path: '/member/detail',
    name: 'MemberDetail',
    component: () => import(/* webpackChunkName: "member" */ '../pages/Member/detail')
  },
  {
    path: '/member/:id/register',
    name: 'MemberRegister',
    component: () => import(/* webpackChunkName: "member" */ '../pages/Member/register')
  },
  {
    path: '/system/user',
    name: 'SystemUser',
    component: () => import(/* webpackChunkName: "system" */ '../pages/System/user')
  },

  {
    path: '/news',
    name: 'News',
    component: () => import(/* webpackChunkName: "news" */ '../pages/Home/newsList')
  },
  {
    path: '/activity',
    name: 'Activity',
    component: () => import(/* webpackChunkName: "activity" */ '../pages/Activity')
  },
  {
	  path: '/activity/:id/list',
	  name: 'ActivityList',
	  component: () => import(/* webpackChunkName: "ActivityList" */ '../pages/Activity/list')
	},
  {
    path: '/activity/:id/detail',
    name: 'ActivityDetail',
    component: () => import(/* webpackChunkName: "activity" */ '../pages/Activity/detail')
  },
  {
    path: '/activity/awards/sign',
    name: 'ActivityAwardSign',
    component: () => import(/* webpackChunkName: "activity" */ '../pages/Activity/awardsSign')
  },
  {
    path: '/activity/:id/sign',
    name: 'ActivitySign',
    component: () => import(/* webpackChunkName: "activity" */ '../pages/Activity/sign')
  },
  {
    path: '/activity/awards',
    name: 'ActivityAwards',
    component: () => import(/* webpackChunkName: "activity" */ '../pages/Activity/awards')
  },
  {
    path: '/contribution',
    name: 'Contribution',
    component: () => import(/* webpackChunkName: "contribution" */ '../pages/Contribution')
  },
  {
    path: '/contribution/:id',
    name: 'ContributionDetail',
    component: () => import(/* webpackChunkName: "contribution" */ '../pages/Contribution/detail')
  },
  {
    path: '/publish',
    name: 'Publish',
    component: () => import(/* webpackChunkName: "publish" */ '../pages/Publish')
  },
  {
    path: '/education',
    name: 'Education',
    component: () => import(/* webpackChunkName: "education" */ '../pages/Education')
  },
  {
    path: '/notice',
    name: 'Notice',
    component: () => import(/* webpackChunkName: "notice" */ '../pages/Notice'),
  },
  {
    path: '/notice/detail',
    name: 'NoticeDetail',
    component: () => import(/* webpackChunkName: "noticeDetail" */ '../pages/Notice/detail')
  },
  {
    path: '/wiki',
    name: 'Wiki',
    component: () => import(/* webpackChunkName: "wiki" */ '../pages/Wiki')
  },
  {
    path: '/party',
    name: 'Party',
    component: () => import(/* webpackChunkName: "wiki" */ '../pages/Party')
  },
  {
    path: '/policy',
    name: 'Policy',
    component: () => import(/* webpackChunkName: "policy" */ '../pages/Policy')
  },
  {
    path: '/aboutus',
    name: 'AboutUs',
    component: () => import(/* webpackChunkName: "aboutus" */ '../pages/AboutUs')
  },
  {
    path: '/aboutus/:id/detail',
    name: 'AboutUsDetail',
    component: () => import(/* webpackChunkName: "aboutus" */ '../pages/AboutUs/detail')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../pages/User/Login')
  },
  {
    path: '/:id/detail',
    name: 'PageDetail',
    component: () => import(/* webpackChunkName: "pageDetail" */ '../pages/Notice/detailActicle')
  },
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  /* 必须调用 `next` */
  let activeMenuUri = '/';
  if (to.name !== 'Home') {
    const activeModule = Store.state.menus.slice(1).find(m => to.path.startsWith(m.uri));
    if (activeModule) {
      activeMenuUri = activeModule.uri;
    } else {
      activeMenuUri = '';
    }
  }
  Store.dispatch('setActiveMenu', {
    activeMenuUri
  });
  next();
})

export default router
